import { FC } from 'react';
import { CatList } from '@blocks-react/components/List';
import { CatListItem } from '@blocks-react/components/ListItem';
import { CatIconSettings } from '@blocks-react/components/Icons/Settings';
import { CatIconCloseCircle } from '@blocks-react/components/Icons/CloseCircle';
import { NotificationPopoverProps } from '../types';

export const NotificationPopover: FC<NotificationPopoverProps> = ({
  handleRedirect,
  title,
  dismissText,
  isActiveNotification,
  handleOpenDismissConfirmationBanner,
}) => {
  return (
    <CatList>
      <CatListItem onBlSelect={handleRedirect}>
        <CatIconSettings
          slot="before"
          data-testid="notification-preference-button"
        />
        {title}
      </CatListItem>
      <CatListItem
        onBlSelect={handleOpenDismissConfirmationBanner}
        disabled={!isActiveNotification}
        data-testid="dismiss-circle-button"
      >
        <CatIconCloseCircle slot="before" />
        {dismissText}
      </CatListItem>
    </CatList>
  );
};
